<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Edit Banner </template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="12">
              <b-row>
                <b-col class="py-3 text-center">
                  <span
                    style="font-size: 20px; font-weight: 500; color: #a7a7a7"
                  >
                    Banner Details
                  </span>
                </b-col>
              </b-row>

              <b-row class="justify-content-md-center">
                <b-col cols="12" md="4">
                  <div :class="{ error: validation.hasError('Heading') }">
                    <b-form-group>
                      <label>Heading</label>
                      <b-form-input
                        v-model="Heading"
                        type="text"
                        id="Heading"
                        placeholder="Heading"
                      />
                      <template
                        slot="description"
                        v-if="validation.firstError('Heading')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Heading")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{ error: validation.hasError('Description') }">
                    <b-form-group>
                      <label>Description</label>
                      <b-form-textarea
                        v-model="Description"
                        type="text"
                        id="description"
                        placeholder="Description"
                      ></b-form-textarea>
                      <template
                        slot="description"
                        v-if="validation.firstError('Description')"
                      >
                        <span style="color: red">{{
                          validation.firstError("Description")
                        }}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>

                <!-- <b-col cols="12" md="8">
                  <b-form-file
                    v-model="Image"
                    @change="uploadPic"
                  ></b-form-file>
                </b-col>
                <b-col cols="12" md="6" class="pt-4">
                  <b-img v-if="bannerImage" :src="bannerImage" fluid></b-img>
                </b-col> -->
              </b-row>
            </b-col>
          </b-row>

          <b-row class="justify-content-center">
            <div class="px-2 pt-4">
              <b-button
                variant="outline-primary"
                size="sm"
                @click.prevent="validateInput"
              >
                Update Banner
              </b-button>
            </div>
          </b-row>

          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,
      Heading: null,
      Description: null,
      Image: null,
      bannerImage: null,
    };
  },

  validators: {
    Heading(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(8)
        .maxLength(256);
    },
    Description(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .minLength(8)
        .maxLength(256);
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/banner/" + this.$route.params.id,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.Heading = response.data.data.heading;
            this.Description = response.data.data.description;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    validateInput() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.editBanner();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    uploadPic(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (files[0].size > 5242880) {
        this.msg = "File Should be less than 5MB";
        this.showsnackbar = true;
        return;
      }
      this.Image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = (e) => {
        this.bannerImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    editBanner() {
      this.appLoading = true;
      var banner = {};
      let formData = new FormData();
      formData.append("id", this.$route.params.id);
      formData.append("heading", this.Heading);
      formData.append("descriptiong", this.Description);
      formData.append("image", this.Image);
      axios({
        method: "PUT",
        url: "/banner",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: formData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$notify({
              group: "appNotification",
              title: "Banner Updated Successfully",
              text: "",
              type: "success",
            });
            this.$router.push("/Banners");
          } else {
            this.msg = response.data.msg;
            var vm = this;
            this.$notify({
              group: "appNotification",
              title: vm.msg,
              text: "",
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
  },
};
</script>
